module.exports = __webpack_public_path__ + "static/media/default-boomer.00ac3634.png";